import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CContainer, CHeader, CHeaderNav, CHeaderToggler, CNavLink, CNavItem } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import AppHeaderDropdown from '../AppHeaderDropdown/Index'
import { setSideBarShow } from "../../../Slices/uiSlice";
import { cilMenu } from '@coreui/icons'

const AppHeader = () => {
    const dispatch = useDispatch();
    const sidebarShow = useSelector((state) => state.ui.sidebarShow);


    return (
        <CHeader position="sticky" className="mb-4">
            <CContainer fluid>
                <CHeaderToggler
                    className="ps-1"
                    onClick={() => dispatch(setSideBarShow(!sidebarShow))}
                >
                    <CIcon icon={cilMenu} size="lg" />
                </CHeaderToggler>
                <CHeaderNav className="d-none d-md-flex me-auto">
                    <CNavItem>
                        <CNavLink
                            onClick={() => dispatch(setSideBarShow(!sidebarShow))}
                            component={NavLink}>
                            Educación Digital
                        </CNavLink>
                    </CNavItem>
                </CHeaderNav>
                <CHeaderNav className="ms-3">
                    <AppHeaderDropdown />
                </CHeaderNav>
                {/* <CHeaderBrand className="mx-auto d-md-none text-center" to="/">
                    <img src={logo} width={'15%'} height={'auto'} />
                </CHeaderBrand> */}
            </CContainer>

        </CHeader>

    )
}

export default AppHeader